import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
import { postData } from "../../FetchNodeServices";
import { InfinitySpin } from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { addUser } from "../../redux/userSlice";
import { useNavigate } from "react-router-dom";
import AlertMessages from "../Mains/Alerts";

const BasicDetails = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [financialYear, setFinancialYear] = useState("Jan - Dec");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneError, setPhoneError] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    setIsFormValid(!!accountName && !!customerName && !!emailId && !!financialYear && !!phoneNumber && !emailError && !phoneError);
  }, [accountName, customerName, emailId, financialYear, phoneNumber, emailError, phoneError]);

  // const handleEmailChange = (event) => {
  //   const emailValue = event.target.value;
  //   const emailRegex = /^[a-zA-Z0-9_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //   if (!emailRegex.test(emailValue)) {
  //     setEmailError("Invalid email address");
  //   } else if (emailValue.split("@")[1].includes(".") && emailValue.split("@")[1].split(".").length > 2) {
  //     setEmailError("Email should not contain multiple periods after the domain.");
  //   } else {
  //     setEmailError(null); // Clear any previous errors
  //   }
  //   setEmailId(emailValue);
  // };
  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    
    // General email validation pattern for local part and domain
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    
    // Split the email into parts for more custom validation
    const [localPart, domainPart] = emailValue.split("@");
  
    // General email pattern validation
    if (!emailRegex.test(emailValue)) {
      setEmailError("Invalid email address format");
    } else if (domainPart && domainPart.split(".").length !== 2) {
      // Ensure there's exactly one dot in the domain part (no subdomains)
      setEmailError("Domain should contain only one dot after '@'");
    } else if (domainPart && domainPart.split(".")[1].length < 2 || domainPart.split(".")[1].length > 4) {
      // Ensure the TLD (suffix) is between 2 to 4 characters long
      setEmailError("Domain suffix should be 2 to 4 characters long");
    } else {
      // Clear any previous errors
      setEmailError(null);
    }
    
    setEmailId(emailValue);
  };
  

  const handlePhoneNumberChange = (event) => {
  const phoneValue = event.target.value;

  // Regex to allow phone numbers in the format +91-9999-2345 or similar
  const phoneRegex = /^\+?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{1,4}$/;

  // Check if the phone number matches the desired format
  if (!phoneRegex.test(phoneValue)) {
    setPhoneError("Invalid phone number format");
  } else {
    setPhoneError(null); // Clear any previous errors if valid
  }

  setPhoneNumber(phoneValue); // Update the state with the entered phone number
};

  

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const handleFinancialYear = (financialYear) => {
    setFinancialYear(financialYear.target.value);
  };

  const handleSubmit = async () => {
    if (!isFormValid) {
      setAlerts([{ variant: "warning", heading: "Please fill in all required fields correctly." }]);
      return;
    }
    setIsLoading(true);
    const formData = {
      accountName: accountName,
      customerName: customerName,
      email: emailId,
      financialYear: financialYear,
      phoneNumber: phoneNumber,
    };
    let result = await postData("users/basic-details", formData);
    if (result) {
      dispatch(addUser({ userId: result.userId, accountId: result.accountId }));
      setIsLoading(false);
      navigate("/billing-detail");
    } else {
      setAlerts([{ variant: "danger", heading: "Something went wrong!" }]);
    }
  };

  const handleClear = () => {
    setAccountName("");
    setCustomerName("");
    setEmailId("");
    setFinancialYear("");
    setPhoneNumber("");
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> Customer Admin
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i>Basic Details
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>
          <div className="steps_box mb-3 fw-600">
            <div>
              <span className="step_count active">1</span> Basic Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <div>
              <span className="step_count">2</span> Billing Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <div>
              <span className="step_count">3</span> Branding
            </div>
          </div>
          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Account Name</label>
                    <input
                      type="text"
                      value={accountName}
                      className="form-control"
                      placeholder="Enter account name"
                      onChange={(event) => setAccountName(event.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Customer Name</label>
                    <input
                      type="text"
                      value={customerName}
                      className="form-control"
                      placeholder="Enter customer name"
                      onChange={(event) => setCustomerName(event.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Email ID</label>
                    <input type="email" value={emailId} className="form-control" placeholder="Enter email-ID" onChange={handleEmailChange} required />
                    {emailError && <div className="text-danger">{emailError}</div>}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Financial Year</label>
                    <select name="" value={financialYear} id="" className="form-control" onChange={handleFinancialYear} required>
                      <option>Select</option>
                      <option value={"Jan - Dec"}>Jan - Dec</option>
                      <option value={"Apr - Mar"}>Apr - Mar</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Phone</label>
                    <input
                      type="tel"
                      value={phoneNumber}
                      className="form-control"
                      placeholder="Enter Phone"
                      inputMode="numeric"
                      maxLength="15"
                      onChange={handlePhoneNumberChange}
                      required
                    />
                    {phoneError && <div className="text-danger">{phoneError}</div>}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div className="button_group">
                  {/* <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleClear()}>
                    Clear Values
                  </button> */}
                </div>
                <div className="button_group">
                  <button type="button" className="btn btn-success px-4" onClick={() => handleSubmit()} disabled={!isFormValid}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
